// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"450":"a23417af","1144":"a23417af","4312":"a23417af","6137":"a23417af","8497":"a23417af","8668":"a23417af"}[chunkId] + ".chunk.css";
};